<script lang="ts">
    export let pharmacy;
    export let date: string;
    export let large: boolean;
</script>
{#if large !== true}
<div class="divide-y divide-gray-300 border-2 rounded p-3 shadow-xl my-auto w-64">
    <p class="text-right">{date}</p>
    <div class="mb-3">
        <p class="font-bold mt-2">
            {pharmacy.pname_1}
        </p>
        <p>
            {pharmacy.pstreet_1}
        </p>
        <p>
            {pharmacy.plocation_1}
        </p>
        <p>
            {pharmacy.pphone_1}
        </p>
    </div>
    {#if pharmacy.pname_2}
    <div>
        <p class="font-bold mt-2">
            {pharmacy.pname_2}
        </p>
        <p>
            {pharmacy.pstreet_2}
        </p>
        <p>
            {pharmacy.plocation_2}
        </p>
        <p>
            {pharmacy.pphone_2}
        </p>
    </div>
    {/if}
</div>
{:else}

<div class="divide-y divide-gray-300 p-3 my-auto w-auto">
    <p class="text-right">{date}</p>
    <div class="mb-3">
        <p class="font-bold mt-2 text-3xl">
            {pharmacy.pname_1}
        </p>
        <p class="text-2xl mt-6">
            {pharmacy.pstreet_1}
        </p>
        <p class="text-2xl">
            {pharmacy.plocation_1}
        </p>
        <p class="text-2xl">
            {pharmacy.pphone_1}
        </p>
    </div>
    {#if pharmacy.pname_2}
    <div class="mb-3">
        <p class="font-bold mt-2 text-3xl">
            {pharmacy.pname_2}
        </p>
        <p class="text-2xl mt-6">
            {pharmacy.pstreet_2}
        </p>
        <p class="text-2xl">
            {pharmacy.plocation_2}
        </p>
        <p class="text-2xl">
            {pharmacy.pphone_2}
        </p>
    </div>
    {/if}
</div>
{/if}